<script>
import isToday from 'date-fns/isToday'
import formatDate from '@utils/format-date'
import { setComputed } from '@state/helpers'

export default {
  filters: {
    formatDate,
  },
  props: {
    date: {
      type: Date,
      required: true,
    },
    availableDates: {
      type: Array,
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
    maxSize: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      calendarOpened: false,
      // https://github.com/nathanreyes/v-calendar/blob/master/README.md#attributes
      calendarAttrs: [
        {
          dot: {
            class: 'has-background-accent',
          },
          contentStyle: {
            class: 'aaaaa',
          },
          dates: [new Date()],
        },
      ],
      calendarSelectedAttrs: {
        contentClass: 'has-background-accent',
      },
    }
  },
  computed: {
    ...setComputed,
    dateIsToday() {
      return isToday(this.date)
    },
    availableDatesFormat() {
      return this.availableDates.length === 0 ? ['1000-01-01'] : this.availableDates;
    }
  },
  methods: {
    onInputDate(value) {
      this.$emit('update:date', value);

      // init value would trigger input event on date picker
      if (value !== this.date) {
        this.$emit('select-date')
      }
    },
    onInputSize(value) {
      this.$emit('update:size', value)
    },
    onChangePage(e) {
      this.$emit('change-page', e)
    }
  },
}
</script>

<template>
  <b-field :class="$style['field']" class="is-style-shadow">
    <div class="control is-split-mobile" :class="$style['field-control']">
      <v-date-picker
        color="primary"
        :value="date"
        :available-dates="availableDatesFormat"
        :attributes="calendarAttrs"
        :popover="{ placement: 'bottom',  visibility: 'click' }"
        :locale="currentLanguage"
        @input="onInputDate"
        @update:from-page="onChangePage"
      >
        <b-button outlined rounded icon-left="calendar" class="is-select-style is-fullwidth">
          {{ date | formatDate('dateWeekDay') }}
          <span
            v-if="dateIsToday"
          >({{ $t('global.TODAY'/*今天*/) }})</span>
        </b-button>
      </v-date-picker>
    </div>
    <b-select
      :class="$style['field-control']"
      :value="size"
      :placeholder="$t('global.GUEST_PLACEHOLDER'/*選擇人數*/)"
      expanded
      rounded
      class="is-split-mobile"
      icon="user-friends"
      @input="onInputSize"
    >
      <option
        v-for="number in maxSize"
        :key="number"
        :value="number"
      >{{number}} {{ $tc('global.GUEST'/* 位 */, number )}}</option>
    </b-select>
  </b-field>
</template>
<style lang="scss" module>
.field {
  @include mobile {
    flex-wrap: wrap;
  }
  &-control {
    @include desktop {
      flex: 1;
    }

    @include mobile {
      flex-basis: 100%;
    }
    &:not(:last-child) {
      @include mobile {
        margin-bottom: 0.5rem;
      }
    }

    :global {
      .button {
        justify-content: left;
        border-width: 1px;
        border-color: $color-border-base;
      }
    }
  }
}
</style>
